import { useState } from 'react';
import { PasswordInput } from '../components/PasswordInput';

export function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: username.trim(), password })
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || 'Prijava nije uspela');
        setLoading(false);
        return;
      }
      localStorage.setItem('auth_token', data.token);
      localStorage.setItem('auth_agent', JSON.stringify(data.agent));
      onLogin(data.token, data.agent);
    } catch (err) {
      setError('Greška u komunikaciji sa serverom');
      setLoading(false);
    }
  };

  const s = {
    wrap: {
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#f5f5f5', fontFamily: 'sans-serif'
    },
    card: {
      background: '#fff', borderRadius: 16, padding: '40px 32px', width: '100%',
      maxWidth: 360, boxShadow: '0 2px 24px rgba(0,0,0,0.08)'
    },
    title: { fontSize: 22, fontWeight: 700, marginBottom: 4, color: '#111' },
    sub: { fontSize: 14, color: '#666', marginBottom: 24 },
    label: { fontSize: 12, color: '#666', marginBottom: 4, display: 'block', fontWeight: 500 },
    input: {
      width: '100%', padding: '10px 12px', fontSize: 14, border: '1px solid #ddd',
      borderRadius: 8, outline: 'none', marginBottom: 14, boxSizing: 'border-box'
    },
    btn: {
      width: '100%', padding: '12px', background: '#185FA5', color: '#fff',
      border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer',
      marginTop: 6
    },
    btnDisabled: {
      background: '#a0b8d0', cursor: 'not-allowed'
    },
    error: {
      background: '#FCEBEB', color: '#791F1F', border: '1px solid #F09595',
      borderRadius: 8, padding: '8px 12px', fontSize: 13, marginBottom: 14
    }
  };

  return (
    <div style={s.wrap}>
      <form style={s.card} onSubmit={handleSubmit}>
        <div style={s.title}>Screen Support</div>
        <div style={s.sub}>Prijava agenta</div>

        {error && <div style={s.error}>{error}</div>}

        <label style={s.label}>Korisničko ime</label>
        <input
          style={s.input}
          type="text"
          value={username}
          onChange={e => setUsername(e.target.value)}
          autoFocus
          autoComplete="username"
          disabled={loading}
        />

        <label style={s.label}>Lozinka</label>
        <PasswordInput
          style={s.input}
          value={password}
          onChange={e => setPassword(e.target.value)}
          autoComplete="current-password"
          disabled={loading}
        />

        <button
          type="submit"
          style={{ ...s.btn, ...(loading || !username || !password ? s.btnDisabled : {}) }}
          disabled={loading || !username || !password}
        >
          {loading ? 'Prijavljivanje...' : 'Prijavi se'}
        </button>
      </form>
    </div>
  );
}
